// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"I7-z","displaySixCardTiles":"J7-z"};